import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectVariablesGlobal } from "../users-selectors";
import { Container, List } from "@mui/material";
import { Body1, H6 } from "../../../../components";
import GlobalVariableItem from "./global-variable-item";
import UsersPagePanel from "../users-page-panel";
import { usersPageSetModal } from "../reducers/users-page-actions";
import UsersPageModal from "../users-page-modal";

const STR = {
  titleVarGlobal: "Variáveis globais",
  subtitleVarGlobal:
    "Aqui você pode visualizar as variáveis globais disponíveis.",
  labelFabVarGlobal: "ADICIONAR",
  titleFabVarGlobal: "Clique aqui para criar uma nova variável global",
};

function GlobalVariavelTab() {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const variablesGlobal = useSelector(selectVariablesGlobal);

  const variablesGlobalFiltered = variablesGlobal?.filter(
    (variable) =>
      variable.nome.toLowerCase().includes(filter.toLowerCase()) ||
      variable.descricao.toLowerCase().includes(filter.toLowerCase())
  );
  const onAdd = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.VARIABLE_GLOBAL_ADD,
      })
    );
  }, [dispatch]);

  return (
    <Container maxWidth="md" disableGutters>
      <H6>{STR.titleVarGlobal}</H6>
      <Body1 align="center">{STR.subtitleVarGlobal}</Body1>
      <UsersPagePanel
        onAdd={onAdd}
        color="info"
        filter={filter}
        setFilter={setFilter}
        icon="Add"
        label={STR.labelFabVarGlobal}
        title={STR.titleFabVarGlobal}
      />
      <List disablePadding>
        {variablesGlobalFiltered?.map((variable) => (
          <GlobalVariableItem
            key={variable.id}
            id={variable.id}
            name={variable.nome}
            value={variable.valor}
            description={variable.descricao}
          />
        ))}
      </List>
    </Container>
  );
}

export default GlobalVariavelTab;
